import React from 'react'
import './Workpages.css'
import rapidkyc from './assets/logo.png'
const Apps = () => {
  return (
    <div className='pl-5 text-white xl:ml-60 md:ml-[15vw] md:mr-8 justify-center sm:mt-20 pb-10'>
    <div className='heading2 md:pl-5 lg:pl-0 lg:text-[55px] md:text-[45px] text-[45px] font-[600] mb-20 md:text-left text-center'>APPS</div> 
    <div className='pl-5 md:grid xl:grid-cols-3 md:grid-cols-2 xl:space-x-3'>
       <div className='flex flex-col justify-evenly p-3 items-center bg-neutral-800 w-[13vw] h-[25vh] text-center rounded-xl'>
          <div className='text-lg'>Rapid KYC</div>
          <div><img src={rapidkyc} alt='icon' width={40}/></div>
          <button className='text-sm py-2 px-3 bg-gray-800 rounded-md'>Download APK</button>
       </div>
    </div>
 </div>
  )
}

export default Apps;